<template>
    <div class="index">
        <video id="playVideos" autoplay webkit-playsinline="true" playsinline="true" x5-video-player-type="h5" x5-video-orientation="portraint" x5-video-player-fullscreen="true" :loop='false' poster="../assets/997/img/1.jpg">
            <source type="video/mp4">
        </video>
         <a-row class="chat-box">
            <a-col :span="12" style="height:100%">
                <div class="pc-tip" v-if="!isPhone">
                    <div class="title">您可以对我说：</div>
                    <a-carousel class="carousel-pic" :autoplay='true' :dots='false'>
                        <div>
                            <ul>
                                <li><span></span>你们的项目是什么？</li>
                                <li><span></span>你们有什么核心技术？</li>
                                <li><span></span>你能做什么？</li>
                                <li><span></span>你们团队成员都有谁？</li>
                                <li><span></span>什么是数字人？</li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li><span></span>数字人的应用场景有哪些？</li>
                                <li><span></span>你们公司在什么位置？</li>
                                <li><span></span>你对你的未来有什么计划？</li>
                                <li><span></span>你和同行相比有什么优势？</li>
                                <li><span></span>目前你们取得了什么成果？</li>
                            </ul>
                        </div>
                        <div>
                            <ul>
                                <li><span></span>你们的商业模式是什么？</li>
                                <li><span></span>你们计划对项目投入多少资金？</li>
                                <li><span></span>市场竞争风险有吗？</li>
                                <li><span></span>你叫什么名字？</li>
                                <li><span></span>你们公司名称是什么？</li>
                            </ul>
                        </div>
                    </a-carousel>
                </div>
                <div v-if="isPhone" class="phone-box">
                    <div class="card-wrapper">
                        <div class="title">您可以对我说：</div>
                        <a-carousel class="carousel-pic" :autoplay='true' :dots='false'>
                            <div>
                                <ul>
                                    <li><span></span>你们的项目是什么？</li>
                                    <li><span></span>你们有什么核心技术？</li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><span></span>你能做什么？</li>
                                    <li><span></span>你们团队成员都有谁？</li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><span></span>什么是数字人？</li>
                                    <li><span></span>数字人的应用场景有哪些？</li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><span></span>你们公司在什么位置？</li>
                                    <li><span></span>你对你的未来有什么计划？</li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><span></span>你和同行相比有什么优势？</li>
                                    <li><span></span>目前你们取得了什么成果？</li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><span></span>你们的商业模式是什么？</li>
                                    <li><span></span>你们计划对项目投入多少资金？</li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><span></span>市场竞争风险有吗？</li>
                                    <li><span></span>你叫什么名字？</li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><span></span>你们公司名称是什么？</li>
                                </ul>
                            </div>
                        </a-carousel>
                    </div>
                </div>
                <img v-if="isPhone" @click="startChat" class="message-chat" src="../assets/img/chat.png" alt="">
                <div v-if="isChating" class="phone-chat">
                    <div class="phone-chat-box">
                        <div class="chat-tip">
                            <span>文本对话</span>
                            <a-icon @click="closeChating" type="close" />
                        </div>
                        <div class="chat-content" id="chatDiv">
                            <div v-for="(item, index) in privateChatContent" :key="index">
                                <div class="robot-box" v-if="item.role=='robot'&&item.content!=''">
                                    <div class="robot-content">
                                        <div>{{item.content}}</div>
                                    </div>
                                </div>

                                <div class="user-box" v-if="item.role=='user'&&item.content!=''">
                                    {{item.content}}
                                </div>
                                <div class="clear"></div>
                            </div>
                        </div>
                        <!-- <div class="input-content">
                            <a-textarea @keyup.13="sendPrivate" v-model="privateContent" style="height:35px;padding-right:40px" placeholder="请输入你想说的话"/>
                            <a-icon @click="sendPrivate" type="enter" />
                        </div> -->
                    </div>
                </div>
            </a-col>
            <a-col :span="12">
                <div class="pc-chat" v-if="!isPhone">
                    <div id="chatDiv">
                        <div v-for="(item, index) in privateChatContent" :key="index">
                            <div class="robot-box" v-if="item.role=='robot'&&item.content!=''">
                                <div class="robot-content">
                                    <div>{{item.content}}</div>
                                </div>
                            </div>

                            <div class="user-box" v-if="item.role=='user'&&item.content!=''">
                                {{item.content}}
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="input-box" style="">
                        <a-row>
                            <a-col :span="12">
                                
                            </a-col>
                            <a-col :span="12" class="send-box">
                                <!-- <a-textarea v-model="privateContent" style="resize: none;border: none;height: 80px;"  placeholder="请输入对话内容" auto-size  @keyup.13="sendPrivate" />
                                <a-button class="resetText" @click="sendPrivate" type="link">
                                    发送
                                </a-button> -->
                                <div class="home" style="margin:1vw;">
                                    <a-button @click="startRecorder()"  style="margin:1vw;" type="primary">
                                    开始对话
                                    </a-button>
                                    <!-- <Button type="info" @click="startRecorder()"  style="margin:1vw;">开始对话</Button> -->
                                    <!-- <Button type="info" @click="resumeRecorder()" style="margin:1vw;">继续录音</Button>
                                    <Button type="info" @click="pauseRecorder()" style="margin:1vw;">暂停录音</Button> -->
                                    <!-- <Button type="info" @click="stopRecorder()" style="margin:1vw;">结束对话</Button> -->
                                    <a-button  @click="stopRecorder()" style="margin:1vw;" type="primary">
                                    结束对话
                                    </a-button>
                                </div>
                            </a-col>
                        </a-row>
                        
                    </div>
                </div>
            </a-col>
        </a-row>
    </div>
</template>
<script>
    import Recorder from 'js-audio-recorder'
    const recorder = new Recorder({
        sampleBits: 16,                 // 采样位数，支持 8 或 16，默认是16
        sampleRate: 16000,              // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
        numChannels: 1,                 // 声道，支持 1 或 2， 默认是1
        compiling: true,//(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
    })
    export default {
        name: 'home-1',
        data () {
            return {
                //波浪图-播放
                timer: null,
                ws: null,
                videoUrl: '../assets/997/video/default.mp4',
                privateChatContent: [],
                privateContent: '',
                roomId: '',
                screenWidth: null,
                isPhone: false,
                isChating: false,
                elevideo: null,
                videoTimeLen: '',
            }
        },
        mounted(){
            this.showConfirm()
            
            this.screenWidth = document.body.clientWidth
            if(this.screenWidth < 500){
                this.isPhone = true
            }
            window.onresize = () => {
                this.screenWidth = document.body.clientWidth
                console.log(this.screenWidth)
                if(this.screenWidth < 500){
                    this.isPhone = true
                }
            }
            
            this.elevideo = document.getElementById("playVideos");
            let that = this

            // this.elevideo.addEventListener('loadedmetadata', function () { 
            //     that.videoTimeLen = that.elevideo.duration
            //     that.timeCarryOut()
            // }); 
            this.elevideo.addEventListener('ended', function () {
                console.log("播放结束")
                that.initVideo()
            }); 
        },
        methods: {
            // 开始录音
            startRecorder () {
                recorder.start().then(() => {
                    console.log("开始绘制")
                    this.ws = new WebSocket("wss://experience.ixiaowen.net:2443/wss/realTimeSpeechRecognition")
                    this.ws.binaryType = 'arraybuffer';
                    let that = this
                    this.ws.onopen = function () {
                        that.ws.send('start')
                        that.timer = setInterval(() => {
                            let data = recorder.getNextData()
                            for(let i = 0; i < data.length; i++){
                                that.ws.send(data[i])
                            }
                        }, 500)
                    }
                    this.ws.onmessage = function (evt) {
                        var received_msg = evt.data
                        console.log(received_msg)
                        that.sendPrivate(received_msg)
                    }
                }, (error) => {
                    // 出错了
                    console.log(`${error.name} : ${error.message}`);
                });
            },
            // 继续录音
            resumeRecorder () {
                recorder.resume()
            },
            // 暂停录音
            pauseRecorder () {
                this.ws.send('stop')
                recorder.pause();
            },
            // 结束录音
            stopRecorder () {
                this.ws.send('stop')
                recorder.stop()
                clearInterval(this.timer)
            },
            /*-----------------视频处理------------------->*/
            initVideo() {
                this.videoUrl = require('../assets/997/video/default.mp4')
                let videos = document.getElementById('playVideos');
                videos.src = this.videoUrl;
                console.log("播放初始化视频")
                // this.currentState = 1
                this.elevideo.removeAttribute("loop")
                this.elevideo.setAttribute("loop", "true");
            },
            changeUrl(url) {
                this.videoUrl = require('../assets/997/video/'+url)
                let videos = document.getElementById('playVideos');
                videos.src = this.videoUrl;
                // this.currentState = 2
                this.elevideo.removeAttribute("loop")
                
            },
            scrollTopCon() {
                this.$nextTick(function() {
                    let div = document.getElementById('chatDiv');
                    div.scrollTop = div.scrollHeight;
                })
            },
            sendPrivate(content) {
                // this.privateContent = (this.privateContent).replace(/\s/g,"");
                // if(this.privateContent.length == 0){
                //     this.$message.error('请输入对话内容');
                //     this.privateContent = ''
                // }else{
                    let obj = {}
                    obj.role = 'user'
                    obj.content = content
                    this.privateChatContent.push(obj)
                    this.scrollTopCon()
                    // this.axios.post('http://www.sipgo.cn/api/project/chat', {//本地用绝对路径
                    this.axios.post('/api/project/chat', {//打包版本用相对路径
                        projectId: 997,
                        roomId: this.roomId,
                        content: content
                    })
                    .then(response=> {
                        if(response.data.code == 0){
                            let newObj = {}
                            newObj.role = 'robot'
                            let arr = response.data.data.responseContent
                            let brr = arr.split("@@")
                            newObj.content = brr[0]
                            if(brr.length > 1){
                                this.changeUrl(brr[1])
                            }
                            let randomTime = this.randomTime()
                            setTimeout(()=>{
                                this.privateChatContent.push(newObj)
                                this.scrollTopCon()
                            },randomTime)
                        }else{
                            this.$message.error(response.data.message);
                        }
                    })
                    .catch(error=> {
                        console.log(error)
                    })
                // }
            },
            randomTime() {
                let max = 3000;
                let min = 1000;
                return Math.round(Math.random()*(max-min)+min)
            },
            getRoomId() {
                // this.axios.post('http://www.sipgo.cn/api/project/chat', {//本地用绝对路径
                this.axios.post('/api/project/chat', {//打包版本用相对路径
                    projectId: 997,
                    roomId: '',
                    content: ''
                })
                .then(response=> {
                    if(response.data.code == 0){
                        // setTimeout(()=>{
                            this.roomId = response.data.data.roomId
                            let obj = {}
                            obj.role = 'robot'
                            obj.content = response.data.data.responseContent.split("@@")[0]
                            this.privateChatContent.push(obj)
                            if(response.data.data.responseContent.split("@@").length > 1){
                                this.changeUrl(response.data.data.responseContent.split("@@")[1])
                            }
                        // },1500)
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            startChat() {
                this.isChating = true
            },
            closeChating() {
                this.isChating = false
            },
            showConfirm() {
                let that = this
                this.$confirm({
                    title: '准备好了开始播放吗?',
                    // content: () => <div style="color:red;">准备开始</div>,
                    onOk() {
                        that.initVideo()
                        that.getRoomId()
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                    class: 'test',
                });
            },
        },
    }
</script>
 
<style lang='less' scoped>
    .index{
        position: relative;
        width: 100%;
        height: 100%;
        background: url('../assets/997/img/banner31.jpg') center/ 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        #playVideos{
            // position: absolute;
            // top: 0px;
            // left: 0px;
            // width: 480px;
            height: 100%;
            // height: 640px;
            // object-fit: cover;
            align-items: center;
            visibility: visible;
            mix-blend-mode: lighten;
        }
        .chat-box{
            position: absolute;
            left: 0px;
            top: 40%;
            z-index: 100;
            width: 100%;
            height: 30%;
            .pc-tip{
                width:55%;
                background: rgba(22,106,255,.6);
                border-radius: 9px;
                margin-left: 40px;
                padding: 40px 20px;
                margin-top: 80px;
                .title{
                    color: #fff; 
                    font-weight: 600;
                    font-size: 16px;
                    padding-left: 14px;
                }
                .carousel-pic{
                    margin-top: 10px;
                    ul{
                        li{
                            display: flex;
                            color: #fff;
                            margin-top:6px;
                            font-size: 15px;
                            span{
                                display: inline-block;
                                width: 6px;
                                height: 6px;
                                border-radius: 3px;
                                margin-right: 8px;
                                background: #fff;
                                float: left;
                                margin-top: 8px;
                            }
                        }
                    }
                }
            }
            
            .phone-box{
                position: absolute;
                left: 20px;
                bottom: -70px;
                z-index: 2;
                .card-wrapper{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    padding: 10px 20px;
                    width: 65vw;
                    background-color: rgba(22,106,255,.6);
                    border-radius: 9px;
                    height: 120px;
                    .title{
                        font-size: 15px;
                        color: #fff;
                        margin-top: 16px;
                        padding-left: 14px;
                    }
                    .carousel-pic{
                        ul{
                            li{
                                display: flex;
                                color: #fff;
                                margin-top:6px;
                                span{
                                    display: inline-block;
                                    width: 6px;
                                    height: 6px;
                                    border-radius: 3px;
                                    margin-right: 8px;
                                    background: #fff;
                                    float: left;
                                    margin-top: 8px;
                                }
                            }
                        }
                    }
                }
            }
            .message-chat{
                position: fixed;
                bottom: 20px;
                right: 20px;
                width: 45px;
                height: 45px;
            }
            .pc-chat{
                position: relative;
                height: 400px;
                #chatDiv{
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    overflow-y: auto;
                    padding: 24px 0;
                    .robot-box{
                        float: left;
                        max-width: 60%;
                        .robot-content{
                            padding: 8px 12px;
                            border-radius: 4px;
                            font-size: 14px;
                            position: relative;
                            color: #000;
                            background: #fff;
                            opacity: 0.7
                        }
                    }
                    .user-box{
                        float: right; 
                        max-width: 60%;
                        padding: 8px 12px;
                        background: rgba(65, 224, 230, 1);
                        color: #fff;
                        font-size: 14px;
                        border-radius: 4px;
                        margin-right: 24px;
                        opacity: 0.7
                    }
                    .clear{
                        clear: both;
                        width: 100%;
                        height: 16px;
                    }
                }
                .input-box{
                    height: 80px;
                    position: absolute;
                    bottom: -90px;
                    width: 100%;
                    padding: 0 24px;
                    .send-box{
                        // button{
                        //     border: none;
                        //     font-size: 14px;
                        //     position: absolute;
                        //     right: 12px;
                        //     bottom: 4px;
                        // }
                    }
                }
            }
            .phone-chat{
                position: fixed;
                bottom: 0px;
                left: 0px;
                width: 100%;
                height: 310px;
                background: #EEEEF6;
                z-index: 10;
                .phone-chat-box{
                    width: 100%;
                    height: 100%;
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    .chat-tip{
                        height: 35px;
                        background: #fff;
                        line-height: 35px;
                        color: #9497A0;
                        padding: 0 16px;
                        i{
                            float: right;
                            margin-top: 12px;
                            font-size: 12px;
                        }
                    }
                    .chat-content{
                        flex: 1;
                        overflow-y: auto;
                        .robot-box{
                            max-width: 70%;
                            padding: 10px;
                            background: #fff;
                            border-radius: 10px;
                            margin-top: 16px;
                            margin-left: 12px;
                            float: left;
                            .robot-content{

                            }
                        }
                        .user-box{
                            max-width: 70%;
                            padding: 10px;
                            background: #fff;
                            border-radius: 10px;
                            margin-top: 16px;
                            margin-right: 12px;
                            float: right;
                        }
                        .clear{
                            clear: both;
                            width: 100%;
                            height: 6px;
                        }
                    }
                    .input-content{
                        width: 100%;
                        padding: 0 16px 16px;
                        position: relative;
                        margin-top: 16px;
                        textarea{
                            resize: none;
                        }
                        i{
                            position: absolute;
                            right: 30px;
                            top: 10px;
                            color: #166AFF;
                            font-size: 22px;
                        }
                    }
                }
            }
        }
    }
</style>